<div class="hub-input" *ngIf="variant === 'default'">
    <label
        class="emd-label"
        [ngClass]="{
            _state_error: control.touched && control.invalid,
        }"
        >{{ inputLabel }}
        <i *ngIf="isRequired"> *</i>
        <i
            *ngIf="useHint"
            name="Clique para mais informações"
            (click)="handleHint($event)"
            class="ipv-help-icon ml-2 fa fa-question-circle"
            aria-hidden="true"
            style="cursor: pointer"
        ></i>
    </label>
    <label class="emd-switcher__label" [for]="id">
        <input
            [id]="id"
            class="emd-switcher _color_primary"
            [(ngModel)]="value"
            type="checkbox"
            [attr.data-cy]="controlName"
        />
        <div class="emd-switcher__area"></div>
        <span class="emd-switcher__text">{{ switcherLabel }}</span>
    </label>
</div>

<div
    class="hub-input eu-display_flex eu-align-items_center"
    style="gap: 1.25rem"
    *ngIf="variant === 'inline'"
>
    <label
        class="emd-label"
        [ngClass]="{
            _state_error: control.touched && control.invalid,
        }"
        >{{ inputLabel }}
        <i *ngIf="isRequired"> *</i>
        <i
            *ngIf="useHint"
            name="Clique para mais informações"
            (click)="handleHint($event)"
            class="ipv-help-icon ml-2 fa fa-question-circle"
            aria-hidden="true"
            style="cursor: pointer"
        ></i>
    </label>
    <label class="emd-switcher__label" [for]="id">
        <input [id]="id" class="emd-switcher _color_primary" [(ngModel)]="value" type="checkbox" />
        <div class="emd-switcher__area"></div>
        <span class="emd-switcher__text">{{ switcherLabel }}</span>
    </label>
</div>
